function initBpAnniversary(){
const bpAnniversaryRoot = document.querySelector('[data-bp-anniversary]');
if(!bpAnniversaryRoot || bpAnniversaryRoot.dataset.bpInitialized === 'true') return;
bpAnniversaryRoot.dataset.bpInitialized = 'true';

// Shopify's theme editor replaces a section after settings (including image
// pickers) change. Remove animation state belonging to the old DOM before the
// replacement is initialized again.
if(window.ScrollTrigger){
  window.ScrollTrigger.getAll().forEach(trigger => {
    const triggerEl = trigger.trigger;
    const pinEl = trigger.pin;
    const belongsToCampaign =
      String(trigger.vars?.id || '').startsWith('bp-') ||
      triggerEl?.closest?.('[data-bp-anniversary]') ||
      pinEl?.closest?.('[data-bp-anniversary]') ||
      (triggerEl && !triggerEl.isConnected) ||
      (pinEl && !pinEl.isConnected);
    if(belongsToCampaign) trigger.kill(true);
  });
}
document.querySelectorAll('.bp-cinematic-progress').forEach(el => el.remove());

// Duplicate each ecosystem row once for a seamless two-direction marquee.
// The clone is decorative so links are removed from the tab order.
bpAnniversaryRoot.querySelectorAll('.eco-stream__track').forEach(track=>{
  const group=track.querySelector('.eco-stream__group');
  if(!group||track.children.length>1)return;
  const clone=group.cloneNode(true);
  clone.setAttribute('aria-hidden','true');
  clone.querySelectorAll('a,button,input').forEach(el=>el.setAttribute('tabindex','-1'));
  track.appendChild(clone);
});

const revealEls = bpAnniversaryRoot.querySelectorAll('.reveal');
const io = new IntersectionObserver((entries)=>{
  entries.forEach(e=>{ if(e.isIntersecting) e.target.classList.add('in'); });
},{threshold:.12});
revealEls.forEach(el=>io.observe(el));

// Match the campaign local-nav height to the active Shopify theme Header.
const bpThemeHeader = document.querySelector(
  '#shopify-section-header .header-wrapper, .shopify-section-header .header-wrapper, .section-header .header-wrapper, .header-wrapper'
);
function syncBpHeaderHeight(){
  if(!bpThemeHeader || !bpAnniversaryRoot) return;
  const height = Math.round(bpThemeHeader.getBoundingClientRect().height);
  if(height >= 40 && height <= 180){
    bpAnniversaryRoot.style.setProperty('--bp-site-header-height', `${height}px`);
    document.documentElement.style.setProperty('--bp-site-header-height', `${height}px`);
  }
}
syncBpHeaderHeight();
addEventListener('resize', syncBpHeaderHeight, {passive:true});
if(bpThemeHeader && 'ResizeObserver' in window){
  new ResizeObserver(syncBpHeaderHeight).observe(bpThemeHeader);
}

// Shopify FAQ blocks: editable in the theme editor and accessible on storefront.
bpAnniversaryRoot?.addEventListener('click', (event) => {
  const question = event.target.closest('.faq-question');
  if(!question || !bpAnniversaryRoot.contains(question)) return;
  const item = question.closest('.faq-item');
  const answer = item?.querySelector('.faq-answer');
  if(!item || !answer) return;
  const willOpen = question.getAttribute('aria-expanded') !== 'true';
  question.setAttribute('aria-expanded', String(willOpen));
  item.classList.toggle('is-open', willOpen);
  answer.hidden = !willOpen;
});

// Restore the chapter locator using the current three sections.
const bpLocalNav = bpAnniversaryRoot.querySelector('#bpLocalNav');
if(bpLocalNav){
  const chapters = [...bpLocalNav.querySelectorAll('.bp-localnav__tab')]
    .map(link => ({ link, section: bpAnniversaryRoot.querySelector(link.getAttribute('href')) }))
    .filter(chapter => chapter.section);
  const firstChapter = chapters[0]?.section;
  let navTick = false;
  let lastNavY = Math.max(0, window.scrollY);
  function updateBpLocalNav(){
    if(navTick) return;
    navTick = true;
    requestAnimationFrame(() => {
      const currentY = Math.max(0, window.scrollY);
      bpLocalNav.classList.toggle('is-stuck', !!firstChapter && firstChapter.getBoundingClientRect().top <= 88);
      if(Math.abs(currentY - lastNavY) > 8){
        bpLocalNav.classList.toggle('is-scrolling-up', currentY < lastNavY);
        lastNavY = currentY;
      }
      let active = chapters[0];
      chapters.forEach(chapter => {
        if(chapter.section.getBoundingClientRect().top <= innerHeight * .35) active = chapter;
      });
      chapters.forEach(chapter => {
        const selected = chapter === active;
        chapter.link.classList.toggle('is-active', selected);
        if(selected) chapter.link.setAttribute('aria-current', 'location');
        else chapter.link.removeAttribute('aria-current');
      });
      navTick = false;
    });
  }
  addEventListener('scroll', updateBpLocalNav, {passive:true});
  addEventListener('resize', updateBpLocalNav, {passive:true});
  updateBpLocalNav();
}

// V7: one observer, no competing scroll engines.
const flowObserver = new IntersectionObserver((entries)=>{
  entries.forEach(e=>{
    if(e.isIntersecting){
      e.target.classList.add('is-in');
      flowObserver.unobserve(e.target);
    }
  })
},{threshold:.18,rootMargin:'0px 0px -8% 0px'});
bpAnniversaryRoot.querySelectorAll('[data-flow]').forEach(el => flowObserver.observe(el));

// V8 restrained parallax: small amplitude, requestAnimationFrame only
let v8Tick=false;
function v8Motion(){
  if(v8Tick) return;
  v8Tick=true;
  requestAnimationFrame(()=>{
    document.querySelectorAll('[data-parallax]').forEach(el=>{
      const r=el.getBoundingClientRect();
      const center=r.top+r.height/2;
      const viewport=innerHeight/2;
      const norm=Math.max(-1,Math.min(1,(center-viewport)/innerHeight));
      el.style.setProperty('--py',`${norm*-10}px`);
    });
    v8Tick=false;
  });
}
addEventListener('scroll',v8Motion,{passive:true});
addEventListener('resize',v8Motion);
v8Motion();

// Anniversary lottery API integration.
const toBase64=buffer=>{
  const bytes=new Uint8Array(buffer);
  let binary='';
  bytes.forEach(byte=>{binary+=String.fromCharCode(byte);});
  return btoa(binary);
};
const createSpinSignature=async({method,pathWithQuery,body,token})=>{
  if(!window.crypto?.subtle)throw new Error('Secure signing is not available in this browser.');
  const encoder=new TextEncoder();
  const key=await crypto.subtle.importKey(
    'raw',
    encoder.encode(token),
    {name:'HMAC',hash:'SHA-256'},
    false,
    ['sign']
  );
  const canonical=`${String(method).toUpperCase()}\n${pathWithQuery}\n${body}`;
  const signature=await crypto.subtle.sign('HMAC',key,encoder.encode(canonical));
  return toBase64(signature);
};
const getSpinErrorMessage=payload=>{
  const code=String(payload?.code??'');
  if(code==='30501')return 'Please enter a valid email address.';
  if(code==='10210')return 'Too many entries. Please wait 10 minutes and try again.';
  if(code==='-1')return 'The prize draw is temporarily unavailable. Please try again.';
  if(code==='30300')return 'The prize draw is temporarily unavailable. Please try again later.';
  return payload?.msg||payload?.message||bpAnniversaryRoot.dataset.spinError;
};
const v8Spin=bpAnniversaryRoot.querySelector('#spinTrigger');
const v8PoolButton=bpAnniversaryRoot.querySelector('[data-prize-pool-open]');
const v8Slot=bpAnniversaryRoot.querySelector('.slot');
const v8Reels=[...bpAnniversaryRoot.querySelectorAll('.reel:not(.reel--pool)')];
const v8PrizePool=[...bpAnniversaryRoot.querySelectorAll('.reel')];
const v8PrizeIds=v8PrizePool.map(reel=>reel.dataset.prizeId);
const v8Gate=bpAnniversaryRoot.querySelector('[data-spin-gate]');
const v8Panel=v8Gate?.querySelector('.spin-gate__panel');
const v8Entry=v8Gate?.querySelector('[data-spin-entry]');
const v8Form=bpAnniversaryRoot.querySelector('[data-spin-form]');
const v8Status=bpAnniversaryRoot.querySelector('[data-spin-status]');
const v8Result=bpAnniversaryRoot.querySelector('[data-spin-result]');
const v8ResultVisual=v8Result?.querySelector('[data-spin-result-visual]');
const v8ResultPrizeName=v8Result?.querySelector('[data-spin-result-prize-name]');
const v8PrizeList=v8Gate?.querySelector('[data-spin-prize-pool]');
// The campaign sections use transforms for their scroll motion, which creates
// a stacking context that can cover a fixed dialog. Mount the dialog directly
// under body so it always sits above the page and remains independently clickable.
if(v8Gate && v8Gate.parentElement !== document.body) document.body.appendChild(v8Gate);
let v8Busy=false;
const v8PrizeMarkup=v8PrizePool.map((reel)=>reel.innerHTML);
v8PrizePool.forEach(reel=>reel.querySelectorAll('img').forEach(source=>{
  const preload=new Image();
  preload.src=source.currentSrc||source.src;
}));
const v8NormalizePrizeText=value=>String(value||'')
  .toLowerCase()
  .replace(/,/g,'')
  .replace(/[×x]/g,' ')
  .replace(/[^a-z0-9]+/g,' ')
  .trim();
// Theme Editor prize slots are ordered to mirror the public draw response.
// Unknown future codes fall through to response-text matching and then a safe visual fallback.
const v8PrizeCodeToNumber=new Map([[0,1],[1,4],[2,7],[3,6],[4,3],[5,2],[6,5],[7,8]]);
const v8PrizeVisualId=prize=>{
  const code=Number(prize?.prize);
  const configuredNumber=v8PrizeCodeToNumber.get(code);
  const configuredPrize=v8PrizePool.find(reel=>Number(reel.dataset.prizeNumber)===configuredNumber);
  if(configuredPrize)return configuredPrize.dataset.prizeId||'';

  const responseText=v8NormalizePrizeText(`${prize?.prizeName||''} ${prize?.prizeContent||''} ${prize?.points||''}`);
  const responseTokens=responseText.split(' ').filter(token=>token.length>2);
  const matchedPrize=v8PrizePool.find(reel=>{
    const configuredText=v8NormalizePrizeText(reel.querySelector('.reel-name')?.textContent);
    return configuredText&&responseTokens.some(token=>configuredText.includes(token));
  });
  if(matchedPrize)return matchedPrize.dataset.prizeId||'';
  if(Number.isFinite(code)&&code>=0&&v8PrizeIds.length)return v8PrizeIds[code%v8PrizeIds.length];
  return v8PrizeIds[0]||'';
};
const v8PrizeDisplayName=prize=>{
  const apiName=String(prize?.prizeName||'').trim();
  const apiContent=String(prize?.prizeContent||'').trim();
  const points=Number(prize?.points);
  if(apiContent)return apiContent;
  if(apiName)return apiName;
  if(Number.isFinite(points)&&points>0)return `${points.toLocaleString('en-US')} Power Credits`;
  return bpAnniversaryRoot.dataset.spinDefaultTitle;
};
const v8AnimateResult=async(slot=0,won=false,prizeId='')=>{
  const matchingIndex=v8PrizeIds.indexOf(prizeId);
  const normalizedSlot=matchingIndex>=0?matchingIndex:Math.max(0,Math.min(v8PrizeMarkup.length-1,Number(slot)||0));
  // A win is three matching symbols; a non-winning pull is deliberately mixed.
  const result=won
    ? [normalizedSlot,normalizedSlot,normalizedSlot]
    : [normalizedSlot,(normalizedSlot+1)%v8PrizeMarkup.length,(normalizedSlot+2)%v8PrizeMarkup.length];
  v8Busy=true;
  v8Slot.classList.add('is-pulling');
  const reduceMotion=matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduceMotion){
    v8Reels.forEach((reel,i)=>{reel.innerHTML=v8PrizeMarkup[result[i]];});
    v8Busy=false;
    v8Slot.classList.remove('is-pulling');
    return;
  }

  // Build each reel once and move one composited strip. Replacing the reel DOM
  // on every frame caused layout/paint churn and made the old spin look choppy.
  const durations=[3000,4000,5000];
  const spinPromises=v8Reels.map((reel,reelIndex)=>{
    const duration=durations[reelIndex];
    const slowDuration=1400;
    const fastStepDuration=150;
    const slowSteps=5;
    const fastSteps=Math.round((duration-slowDuration)/fastStepDuration);
    const moveCount=fastSteps+slowSteps;
    const reelHeight=Math.round(reel.getBoundingClientRect().height);
    const currentMarkup=reel.innerHTML;
    const strip=document.createElement('div');
    strip.className='bp-slot__strip';
    strip.style.setProperty('--bp-slot-reel-height',`${reelHeight}px`);
    // Keep the result at the top of the strip and start from its bottom edge.
    // Returning the strip to zero makes the symbols travel visually downward.
    const symbols=[v8PrizeMarkup[result[reelIndex]]];
    for(let step=1;step<moveCount;step+=1){
      symbols.push(v8PrizeMarkup[(step+reelIndex*2)%v8PrizeMarkup.length]);
    }
    symbols.push(currentMarkup);
    symbols.forEach(markup=>{
      const item=document.createElement('div');
      item.className='bp-slot__strip-item';
      item.innerHTML=markup;
      item.querySelectorAll('img').forEach(img=>{
        img.loading='eager';
        img.decoding='async';
      });
      strip.appendChild(item);
    });
    reel.classList.add('is-spinning');
    reel.replaceChildren(strip);
    const travel=(symbols.length-1)*reelHeight;
    const fastTravel=fastSteps*reelHeight;
    const fastEnd=(duration-slowDuration)/duration;
    const animation=strip.animate([
      {transform:`translate3d(0,${-travel}px,0)`,offset:0,easing:'linear'},
      {transform:`translate3d(0,${-travel+fastTravel}px,0)`,offset:fastEnd,easing:'linear'},
      {transform:`translate3d(0,${-travel+(fastSteps+slowSteps*.55)*reelHeight}px,0)`,offset:fastEnd+(1-fastEnd)*.38,easing:'linear'},
      {transform:`translate3d(0,${-travel+(fastSteps+slowSteps*.85)*reelHeight}px,0)`,offset:fastEnd+(1-fastEnd)*.72,easing:'linear'},
      {transform:'translate3d(0,0,0)',offset:1}
    ],{duration,fill:'forwards'});
    return animation.finished.catch(()=>{}).then(()=>{
      reel.classList.remove('is-spinning');
      reel.innerHTML=v8PrizeMarkup[result[reelIndex]];
    });
  });
  await Promise.all(spinPromises);
  v8Busy=false;
  v8Slot.classList.remove('is-pulling');
};
if(v8Spin && v8PoolButton && v8Slot && v8Gate && v8Panel && v8Entry && v8Form && v8Result && v8ResultVisual && v8ResultPrizeName && v8PrizeList){
  let pending=false,oldOverflow='',gateReturnFocus=v8Spin;
  const consent=v8Form.querySelector('[data-spin-consent]');
  const submit=v8Form.querySelector('[type="submit"]');
  const syncSubmit=()=>{if(submit)submit.disabled=pending||!consent?.checked;};
  consent?.addEventListener('change',()=>{v8Status.textContent='';syncSubmit();});
  syncSubmit();
  const closeGate=()=>{if(pending)return;v8Gate.hidden=true;document.body.style.overflow=oldOverflow;gateReturnFocus?.focus();};
  const openSpinGate=trigger=>{
    if(v8Busy||pending)return;
    gateReturnFocus=trigger;
    oldOverflow=document.body.style.overflow;document.body.style.overflow='hidden';v8Gate.hidden=false;
    v8Entry.hidden=false;v8Result.hidden=true;v8PrizeList.hidden=true;v8Status.textContent='';
    v8Panel.classList.remove('is-result','is-prize-pool');
    v8Panel.setAttribute('aria-labelledby','spinGateTitle');
    requestAnimationFrame(()=>v8Form.elements.email?.focus());
  };
  v8Spin.addEventListener('click',()=>openSpinGate(v8Spin));
  v8Slot.addEventListener('click',()=>openSpinGate(v8Slot));
  v8Slot.addEventListener('keydown',event=>{
    if(event.key!=='Enter'&&event.key!==' ')return;
    event.preventDefault();
    openSpinGate(v8Slot);
  });
  v8PoolButton.addEventListener('click',()=>{
    if(v8Busy||pending)return;
    gateReturnFocus=v8PoolButton;
    oldOverflow=document.body.style.overflow;document.body.style.overflow='hidden';v8Gate.hidden=false;
    v8Entry.hidden=true;v8Result.hidden=true;v8PrizeList.hidden=false;
    v8Panel.classList.remove('is-result');
    v8Panel.classList.add('is-prize-pool');
    v8Panel.setAttribute('aria-labelledby',v8PrizeList.querySelector('h3').id);
    requestAnimationFrame(()=>v8Gate.querySelector('[data-spin-close].spin-gate__close')?.focus());
  });
  v8Gate.querySelectorAll('[data-spin-close]').forEach(el=>el.addEventListener('click',closeGate));
  v8Gate.addEventListener('keydown',event=>{
    if(event.key==='Escape'){event.preventDefault();closeGate();}
    if(event.key==='Tab'){
      const items=[...v8Gate.querySelectorAll('button,input,a[href]')].filter(el=>!el.disabled&&el.getClientRects().length);
      const first=items[0],last=items.at(-1);
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
    }
  });
  v8Form.addEventListener('submit',async(event)=>{
    event.preventDefault();
    if(v8Busy||pending)return;
    const email=String(new FormData(v8Form).get('email')||'').trim();
    if(email.length>255||!/^\S+@\S+\.\S+$/.test(email)){
      v8Status.textContent=bpAnniversaryRoot.dataset.spinInvalidEmail;
      return;
    }
    if(!consent?.checked){
      v8Status.textContent='Please agree to the privacy policy before playing.';
      return;
    }
    const endpoint=bpAnniversaryRoot.dataset.spinEndpoint;
    const signToken=bpAnniversaryRoot.dataset.spinToken;
    if(!endpoint||!signToken){
      v8Status.textContent=bpAnniversaryRoot.dataset.spinNotConnected;
      return;
    }
    submit.disabled=true;pending=true;
    v8Status.textContent='';
    try{
      const apiUrl=new URL(endpoint,location.origin);
      if(!['http:','https:'].includes(apiUrl.protocol))throw new Error(bpAnniversaryRoot.dataset.spinError);
      const body=JSON.stringify({email});
      const signature=await createSpinSignature({
        method:'POST',
        pathWithQuery:`${apiUrl.pathname}${apiUrl.search}`,
        body,
        token:signToken
      });
      const response=await fetch(apiUrl.href,{
        method:'POST',
        headers:{
          'Content-Type':'application/json',
          'Accept':'application/json',
          'X-SHOPIFY-SUPPORT-SIGNATURE':signature
        },
        signal:AbortSignal.timeout(20000),
        body
      });
      const payload=await response.json().catch(()=>({}));
      if(!response.ok||String(payload.code)!=='200')throw new Error(getSpinErrorMessage(payload));
      if(!payload.data||!Object.prototype.hasOwnProperty.call(payload.data,'prize'))throw new Error(bpAnniversaryRoot.dataset.spinError);
      const prize=payload.data||{};
      const prizeCode=Number(prize.prize)||0;
      const prizeVisualId=v8PrizeVisualId(prize);
      const replayed=prize.replayed===true;
      if(!replayed){
        // Only new draws play the slot animation. A replayed response is the
        // customer's existing result, so reveal it immediately.
        v8Gate.hidden=true;
        document.body.style.overflow=oldOverflow;
        // Every successful response awards a prize. Code 0 is the guaranteed
        // points reward and uses the same three-matching-reels result flow.
        await v8AnimateResult(prizeCode,true,prizeVisualId);
        await new Promise(resolve=>setTimeout(resolve,1000));
      }
      v8Entry.hidden=true;
      v8PrizeList.hidden=true;
      v8Result.hidden=false;
      const prizeName=v8PrizeDisplayName(prize);
      const prizeSource=v8PrizePool.find(reel=>reel.dataset.prizeId===prizeVisualId);
      const prizeVisual=prizeSource?.querySelector('.reel-prize-image,.reel-prize-symbol')?.cloneNode(true);
      v8Result.querySelector('[data-spin-result-title]').textContent='You Won!';
      v8ResultPrizeName.textContent=prizeName;
      v8ResultVisual.replaceChildren();
      if(prizeVisual){
        prizeVisual.removeAttribute('loading');
        if(prizeVisual.tagName==='IMG')prizeVisual.alt=prizeName;
        v8ResultVisual.appendChild(prizeVisual);
        v8ResultVisual.hidden=false;
      }else{
        v8ResultVisual.hidden=true;
      }
      v8Panel.classList.add('is-result');
      v8Panel.classList.remove('is-prize-pool');
      v8Panel.setAttribute('aria-labelledby',v8Result.querySelector('[data-spin-result-title]').id);
      document.body.style.overflow='hidden';
      v8Gate.hidden=false;
      v8Gate.querySelector('[data-spin-close].spin-gate__close')?.focus();
    }catch(error){
      const timedOut=error?.name==='TimeoutError'||error?.name==='AbortError';
      v8Status.textContent=timedOut?bpAnniversaryRoot.dataset.spinError:(error.message||bpAnniversaryRoot.dataset.spinError);
    }finally{
      pending=false;syncSubmit();
    }
  });
}



    const track=bpAnniversaryRoot.querySelector('.bp-diy-carousel');
    const prev=bpAnniversaryRoot.querySelector('[data-mount-prev]');
    const next=bpAnniversaryRoot.querySelector('[data-mount-next]');
    const pagination=bpAnniversaryRoot.querySelector('[data-mount-pagination]');
    let observer;
    if(track&&prev&&next){
      const cards=[...track.querySelectorAll('.bp-diy-card')];
      const stepFor=()=>cards[0] ? cards[0].getBoundingClientRect().width+(parseFloat(getComputedStyle(track).gap)||0) : 0;
      const pagePositions=()=>{
        const step=stepFor();
        const max=Math.max(0,track.scrollWidth-track.clientWidth);
        if(!step||max<=1)return [0];
        const positions=[];
        for(let left=0;left<max;left+=step)positions.push(left);
        positions.push(max);
        return positions.filter((left,index,list)=>index===0||Math.abs(left-list[index-1])>2);
      };
      const pageFor=()=>{
        const positions=pagePositions();
        return positions.reduce((best,left,index)=>Math.abs(track.scrollLeft-left)<Math.abs(track.scrollLeft-positions[best])?index:best,0);
      };
      const buildPagination=()=>{
        if(!pagination)return;
        const positions=pagePositions();
        if(pagination.childElementCount===positions.length)return;
        pagination.replaceChildren(...positions.map((left,index)=>{
          const dot=document.createElement('button');
          dot.type='button';
          dot.setAttribute('aria-label',`Go to mount page ${index+1}`);
          dot.addEventListener('click',()=>track.scrollTo({left:pagePositions()[index]??left,behavior:bpReduceMotion?'instant':'smooth'}));
          return dot;
        }));
      };
      const update=()=>{
        buildPagination();
        const positions=pagePositions();
        const page=pageFor();
        prev.disabled=page===0||track.scrollLeft<=2;
        next.disabled=page===positions.length-1||track.scrollLeft>=positions.at(-1)-2;
        prev.setAttribute('aria-disabled',String(prev.disabled));
        next.setAttribute('aria-disabled',String(next.disabled));
        pagination?.querySelectorAll('button').forEach((dot,index)=>{
          const active=index===page;
          dot.classList.toggle('is-active',active);
          dot.setAttribute('aria-current',active?'true':'false');
        });
      };
      const move=direction=>{
        const positions=pagePositions();
        const destination=Math.max(0,Math.min(positions.length-1,pageFor()+direction));
        track.scrollTo({left:positions[destination],behavior:bpReduceMotion?'instant':'smooth'});
      };
      prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
      let updateFrame=0;
      track.addEventListener('scroll',()=>{
        if(updateFrame)return;
        updateFrame=requestAnimationFrame(()=>{updateFrame=0;update();});
      },{passive:true});

      let dragStartX=0,dragStartScroll=0,dragTargetScroll=0,dragPointerId=null,didDrag=false,dragFrame=0;
      track.addEventListener('pointerdown',event=>{
        if(event.pointerType==='touch'||event.button!==0)return;
        dragPointerId=event.pointerId;
        dragStartX=event.clientX;
        dragStartScroll=track.scrollLeft;
        dragTargetScroll=track.scrollLeft;
        didDrag=false;
        track.classList.add('is-dragging');
        track.setPointerCapture?.(event.pointerId);
      });
      track.addEventListener('pointermove',event=>{
        if(event.pointerId!==dragPointerId)return;
        const distance=event.clientX-dragStartX;
        if(Math.abs(distance)>5)didDrag=true;
        if(didDrag){
          event.preventDefault();
          const max=Math.max(0,track.scrollWidth-track.clientWidth);
          dragTargetScroll=Math.max(0,Math.min(max,dragStartScroll-distance));
          if(!dragFrame)dragFrame=requestAnimationFrame(()=>{
            dragFrame=0;
            track.scrollLeft=dragTargetScroll;
          });
        }
      });
      const endDrag=event=>{
        if(event.pointerId!==dragPointerId)return;
        if(dragFrame){cancelAnimationFrame(dragFrame);dragFrame=0;track.scrollLeft=dragTargetScroll;}
        track.releasePointerCapture?.(event.pointerId);
        dragPointerId=null;
        track.classList.remove('is-dragging');
        if(didDrag){
          const positions=pagePositions();
          track.scrollTo({left:positions[pageFor()],behavior:bpReduceMotion?'instant':'smooth'});
        }
      };
      track.addEventListener('pointerup',endDrag);
      track.addEventListener('pointercancel',endDrag);
      track.addEventListener('dragstart',event=>event.preventDefault());
      track.addEventListener('click',event=>{
        if(!didDrag)return;
        event.preventDefault();
        event.stopPropagation();
        didDrag=false;
      },true);

      observer=new ResizeObserver(()=>{buildPagination();update();});observer.observe(track);update();
    }

// V9: device-aware motion and resize stability
const bpIsTouch = matchMedia('(hover:none), (pointer:coarse)').matches;
const bpReduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

// Disable parallax on touch/reduced-motion to improve battery + scroll performance.
if(bpIsTouch || bpReduceMotion){
  document.querySelectorAll('[data-parallax]').forEach(el=>{
    el.style.setProperty('--py','0px');
  });
}

// Recalculate only when orientation / viewport class really changes.
let bpLastW = innerWidth;
let bpLastH = innerHeight;
addEventListener('resize',()=>{
  const dw = Math.abs(innerWidth - bpLastW);
  const dh = Math.abs(innerHeight - bpLastH);
  if(dw > 40 || dh > 120){
    bpLastW = innerWidth;
    bpLastH = innerHeight;
    document.documentElement.style.setProperty('--vh',`${innerHeight * .01}px`);
  }
},{passive:true});
document.documentElement.style.setProperty('--vh',`${innerHeight * .01}px`);


// =========================================================
// V20 — GSAP cinematic scroll interactions
// =========================================================
(() => {
  if (!window.gsap || !window.ScrollTrigger) return;

  gsap.registerPlugin(ScrollTrigger);

  const mm = gsap.matchMedia();
  mm.add({
    desktop: '(min-width: 768px)',
    mobile: '(max-width: 767px)',
    reduceMotion: '(prefers-reduced-motion: reduce)'
  }, (context) => {
    const { desktop, reduceMotion } = context.conditions;

    if (reduceMotion) {
      gsap.set('.reveal,[data-flow]', {
        autoAlpha: 1,
        clearProps: 'transform'
      });
      return;
    }

    // Layered Scroll Motion: preserve full contrast while copy and visuals
    // move at different amplitudes. Opacity stays at 1 throughout scrolling.
    gsap.utils.toArray('.chapter-review > .section, .chapter-firmware > .section, .chapter-event > .section')
      .forEach((section) => {
        const copy = section.querySelector('[data-flow="copy"]') ||
          section.querySelector('.container > div:first-child');
        const visual = section.querySelector('[data-flow="visual"]');
        const depth = section.querySelector('[data-parallax]');
        const cards = section.querySelectorAll('.award,.post-card,.reward-card,.step,.feature');

        if (copy) {
          gsap.fromTo(copy,
            { y: desktop ? 52 : 28 },
            {
              y: desktop ? -20 : 0,
              ease: 'none',
              scrollTrigger: {
                trigger: section,
                start: 'top 88%',
                end: 'bottom 32%',
                scrub: desktop ? .8 : .35
              }
            });
        }

        if (visual && visual !== copy) {
          gsap.fromTo(visual,
            { y: desktop ? 90 : 36, scale: .975 },
            {
              y: desktop ? -34 : 0,
              scale: 1,
              ease: 'none',
              scrollTrigger: {
                trigger: section,
                start: 'top 92%',
                end: 'bottom 28%',
                scrub: desktop ? 1.05 : .4
              }
            });
        }

        if (depth && desktop) {
          gsap.fromTo(depth, { yPercent: 7 }, {
            yPercent: -7,
            ease: 'none',
            scrollTrigger: {
              trigger: section,
              start: 'top bottom',
              end: 'bottom top',
              scrub: 1.2
            }
          });
        }

        if (cards.length && desktop) {
          gsap.fromTo(cards,
            { y: 42 },
            {
              y: 0,
              duration: .7,
              ease: 'power3.out',
              stagger: { each: .075, from: 'start' },
              overwrite: 'auto',
              scrollTrigger: {
                trigger: cards[0].parentElement,
                start: 'top 84%',
                toggleActions: 'play none none reverse'
              }
            });
        }
      });

    // Hero depth sets up the first chapter without introducing another pin.
    // The guard keeps ScrollTrigger valid when the merchant hides/removes the
    // Hero content block in Shopify's theme editor.
    const hero = bpAnniversaryRoot.querySelector('.hero');
    if (hero) {
      gsap.timeline({
        scrollTrigger: {
          trigger: hero,
          start: 'top top',
          end: 'bottom top',
          scrub: desktop ? .8 : .35
        }
      })
        .to(hero.querySelector('.hero-image'), { scale: 1.08, yPercent: 7, ease: 'none' }, 0);
    }

    return () => gsap.set('[data-flow],[data-parallax]', { clearProps: 'transform' });
  });

  // Refresh after embedded imagery/fonts settle; never refresh on every frame.
  addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
})();

}

initBpAnniversary();

// Rebind all interactions whenever Shopify swaps this section in the theme
// editor. This is the event fired after image/text/block settings are saved.
document.addEventListener('shopify:section:load', (event) => {
  if(event.target?.matches?.('[data-bp-anniversary]') || event.target?.querySelector?.('[data-bp-anniversary]')){
    initBpAnniversary();
  }
});



// =========================================================
// V21 — Monumental, artifact-led cinematic layer
// Inspired by the pacing of Hall of Legends, adapted to BP.
// =========================================================
(() => {
  if (!window.gsap || !window.ScrollTrigger) return;

  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // The hero opens as a stable image. The introduction below it owns the
  // scroll transition instead of running a separate entrance animation.


  if (!reduceMotion) {
    // Light catches the artifact/card surfaces once, echoing the reference's
    // polished exhibit feeling without adding canvas or shader cost.
    ScrollTrigger.batch('.award,.post-card,.reward-card,.step', {
      start: 'top 78%',
      once: true,
      interval: .08,
      batchMax: 4,
      onEnter: (batch) => batch.forEach((card, i) => {
        gsap.to(card, {
          '--bp-catch': 1,
          duration: .01,
          delay: i * .06,
          onStart: () => card.classList.add('bp-light-catch')
        });
      })
    });

  }

  // Native pseudo-elements cannot be tween targets. A class-driven shine is
  // cheaper and keeps the effect entirely on the compositor.
  const shineStyle = document.createElement('style');
  shineStyle.textContent = `
    .bp-light-catch::after{animation:bpLightCatch 1.05s cubic-bezier(.16,1,.3,1) both}
    @keyframes bpLightCatch{0%{opacity:0;transform:translateX(-110%)}34%{opacity:.52}100%{opacity:0;transform:translateX(110%)}}
    @media(prefers-reduced-motion:reduce){.bp-light-catch::after{animation:none}}
  `;
  document.head.appendChild(shineStyle);

  addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
})();
